'use strict';
define(
	'domControl',['jquery', 'settings', 'translations', 'domBids', 'util', 'rollNumber', 'jackpots',
		'jackpotDom', 'errorHandler', 'pokerCards', 'pokerMap'
	],
	function ($, settings, T, domBids, Util, rollNumber, Jackpot, jackpotDom, errorHandler, pokerCards, pokerMap) {
		let singleScreen;
		const games = {};
		const roller = rollNumber(specialFormat);
		const hotCold = [];
		const gamesTimeLeft = [];

		function loadTemplate(content) {
			$('#content-wrapper').html(content);
			singleScreen = settings.games.length < 2;

			_translateFields();
		}
		function _updateJackpotMessage() { }

		function _errorDisplay(message, time) {
			errorHandler.showError(T.translate(message), time);
		}

		function showScreen() {
			$('#fadeout').fadeOut(500, 'linear');
		}

		function setSlider(time, placement) {
			const adder = games[placement]
			$(adder + '.modern-dom > .progress-bar .progress')
				.css({ width: 0 }).stop().animate({ width: '100%' }, time, 'linear');
		}

		function _loadSelectors() {
			settings.games.forEach(function (game, gameNo) {
				const adder = settings.games.length === 2 ? '#game-' + gameNo + ' ' : '';
				const isPoker = game.module === 'betgames-poker';

				games[gameNo] = adder;

				if (isPoker) {
					$(adder + 'header .block.info.col .block-top.col').addClass('poker');
					$(adder + 'header .block.info.col').addClass('poker');
					$(adder + 'header .info .block-bottom').addClass('poker');
					$(adder + '.block.timer.col').addClass('poker');
				}

				jackpotDom.setFunctions(_errorDisplay, _updateJackpotMessage, specialFormat);
				jackpotDom.init({
					jackpot: $(adder + '.jackpot'),
					jackpotWinner: $('.jackpot-winner'),
					jackpotSwitch: $(adder + 'header .money')
				}, gameNo);
				if (game.jackpotURLs && game.jackpotURLs.length > 0) {
					Jackpot.registerJackpots(settings.games[gameNo].jackpotURLs, gameNo);
					$(adder + 'header .money').addClass('small');
				}
			});
		}

		function getGameSelectors(adder) {
			return {
				header: {
					container: $(adder + 'header'),
					timeLeft: $(adder + 'header .timer .timer-time'),
					timerUnit: $(adder + 'header .timer .timer-unit'),
					round: $(adder + 'header .timer .round'),
					dealingCards: $(adder + 'header .timer .dealing-cards'),
					betsAreClosed: $(adder + 'header .timer .bets-are-closed'),
					stake: $(adder + 'header .stake .block-bottom .number'),
					gameCode: $(adder + 'header .block.info .block-top.col .game-code')
				},
				progressBar: $(adder + '.modern-dom > .progress-bar .progress'),
				results: {
					latest: $(adder + 'section.results'),
					history: $(adder + '.history'),
					historySection: $(adder + 'section.history'),
					all: $(adder + '.history .history-group, ' + adder + ' section.results')
				},
				odds: {
					all: $(adder + '.odds .all'),
					popular: $(adder + '.odds .popular'),
					both: $(adder + '.odds'),
					available: null,
					pageNo: $(adder + '.odds .all .odd-page-indication'),
					pageBar: $(adder + '.odds .all .progress-bar')
				},
				jackpots: {
					jackpot: $(adder + '.jackpot'),
					jackpotWinner: $('.jackpot-winner'),
					jackpotSwitch: $(adder + 'header .money')
				}
			}
		}

		function _translateFields() {
			_loadSelectors();

			if (singleScreen) {
				$('body').attr('data-game',
					settings.games[0].config[settings.games[0].module].gameType);
					$('body').attr('data-template', settings.local.template);

				if (settings.local.design) {
					$('body').attr('data-design', settings.local.design);
				}
			} else {
				$('body').attr('data-template', 'modern');
			}

			Object.keys(games).forEach(gameNo => {
				const adder = games[gameNo];
				const selectors = getGameSelectors(games[gameNo])

				var gameConfig = settings.games[gameNo].config[settings.games[gameNo].module];

				if (!singleScreen) {
					$('body').find('#game-' + gameNo).attr('data-game', gameConfig.gameType);
				}

				selectors.header.container.find('.logo-text')
					.html(T.translate('translate_' + gameConfig.gameType + '_title'));
				selectors.results.all.find('.date .title').html(T.translate('translate_date'));
				selectors.results.all.find('.draw .title').html(T.translate('translate_inst_history'));
				selectors.results.latest.find('.result-title').html(T.translate('translate_results'));

				selectors.header.container.find('.info .block-top .live-broadcast')
					.html(T.translate('translate_online_lotto'));
					selectors.header.container.find('.info .block-bottom span').first()
					.html(T.translate('translate_' + gameConfig.gameType + '_title')).next()
					.html(T.translate(
						gameConfig.gameType !== 'poker' ?
						'translate_' + gameConfig.gameType + '_count' :
						''
					));
				selectors.header.container.find('.timer .timer-unit')
					.html(T.translate('translate_time_unit'));
				selectors.header.container.find('.timer .bets-are-closed')
					.html(T.translate('translate_bets_are_closed'));
				selectors.header.container.find('.stake .block-top')
					.html(T.translate('translate_total_stakes'));

				selectors.odds.popular.find('.odd-header .odd-title')
					.html(T.translate('translate_' + gameConfig.gameType + '_bets'));
				selectors.odds.all.find('.group-left div').first()
					.html(T.translate('translate_all_bets'))
					.next().find(gameConfig.gameType !== 'poker' ? '.odd-ask-all' : '')
					.html(T.translate('translate_additional_message'));
				selectors.odds.both.find('.odd-header .odd-stake').html(T.translate('translate_stake'));
				selectors.odds.both.find('.odd-header .odd-no').html(T.translate('translate_odd'));

				if (gameConfig.gameType === 'lucky6') {
					selectors.results.all.find('.date .title')
						.html(T.translate('translate_latest_time'));
					selectors.results.history.find('.date .title')
						.html(T.translate('translate_history_time'));
					selectors.results.history.find('.draw .title')
						.html(T.translate('translate_all_history'));
					selectors.results.history.find('.history-cold-hot-title')
						.html(T.translate('translate_cold_and_hot'));
					selectors.results.history.find('#history-last-100')
						.html(T.translate('translate_last_draws'));
					selectors.results.history.find('#cold-history .cold-hot-titles')
						.html(T.translate('translate_cold'));
					selectors.results.history.find('#hot-history .cold-hot-titles')
						.html(T.translate('translate_hot'));
					_updateTimes(gameNo);
				}
				if (gameConfig.gameType === 'poker') {
					selectors.header.container.find('.logo-text')
					.html(T.translate('translate_' + gameConfig.gameType + '_logo_title'));
					selectors.odds.all.find('.group-left div').first()
					.html(T.translate('translate_poker_combinations'))

					$('body').find('.history').empty();
					$('body').find('.history').css({'height':'17.5vh', 'padding': '0', 'padding-top': '1.5vh'});
					selectors.odds.pageNo.remove();
					selectors.odds.pageBar.remove();
					selectors.header.dealingCards.html(T.translate('translate_poker_dealing_cards'));
				}
			});
		}

		function showBets(bets, placement) {
			const selectors = getGameSelectors(games[placement]);

			domBids.initialize(selectors, bets, placement, roller);
		}

		function showHistory(history, placement) {
			const gameConfig = settings.games[placement].config[settings.games[placement].module];

			if (gameConfig.gameType === 'poker') {
				history.forEach((item, index) => {
					_setResultData(index, item);
				})
				return;
			}

			const selectors = getGameSelectors(games[placement]);

			history.forEach(function (historyElement, i) {
				if (gameConfig.gameType === 'lucky6') {
					_updateHotAndColdNumbers(historyElement, placement);
				}
				if (i < selectors.results.all.length) {
					_setResultData($(selectors.results.all[i]), historyElement);
				}
			});
		}

		function setFullScreenPoker() {
			$('body').find('#player-volume').addClass('poker-volume');
			$('body').find('#player').addClass('poker');
		}

		function setTimeLeft(time, placement, currentGame) {
			const selectors = getGameSelectors(games[placement]);
			const gameConfig = settings.games[placement].config[settings.games[placement].module];
			const updatedTime = time >= 0 ? time : 0;

			gamesTimeLeft[placement] = updatedTime;

			if (currentGame && gameConfig.gameType === 'poker') {
				const activeRound = currentGame.data.rounds.find(round => round.isActive);

				return activeRound && selectors
					.header
					.round
					.html(T.translate(`poker.round_${activeRound.ID}`));
			}
		}

		setInterval(function () {
			gamesTimeLeft.forEach(function (time, placement) {
				const selectors = getGameSelectors(games[placement]);
				const gameConfig = settings.games[placement].config[settings.games[placement].module];
				const isPoker = gameConfig.gameType === 'poker';

				if (time > 0) {
					selectors.header.timeLeft.show();

					if (isPoker) {
						selectors.header.dealingCards.removeClass('show');
						selectors.header.round.show();
					} else {
						selectors.header.timerUnit.removeClass('hide');
						selectors.header.betsAreClosed.removeClass('show');
					}

					gamesTimeLeft[placement] -= 1;
					selectors.header.timeLeft.html(time);
					checkJackpots(placement);
				} else {
					domBids.stopSlider();
					selectors.header.timeLeft.hide();

					if (isPoker) {
						selectors.header.dealingCards.addClass('show');
						selectors.header.round.hide();
						domBids.lockBets(placement);
					} else {
						selectors.header.timerUnit.addClass('hide');
						selectors.header.betsAreClosed.addClass('show');
					}
				}
			});
		}, 1000);

		function checkJackpots(gameNo) {
			if (Jackpot.jackpotWinners.length > 0) {
				jackpotDom.showJackpotWinner(Jackpot.jackpotWinners.shift(), gameNo);
			}
		}

		const suitSymbol = (suit, value) => {
			switch (suit) {
				case 'diamonds':
					return `<span class="card diamonds">${value} &diams;</span>`;
				case 'hearts':
					return `<span class="card hearts">${value} &hearts;</span>`;
				case 'clubs':
					return `<span class="card clubs">${value} &clubs;</span>`;
				case 'spades':
					return `<span class="card spades">${value} &spades;</span>`;
				default:
					return;
			}
		};

		let boardCards = [];
		let playerCards = [];

		const getPokerCards = (event) => {
			boardCards = [];
			playerCards = [];
			event.data.rounds.forEach(round => {
				round.cards.forEach(card => {
					const cardObj = suitSymbol(
						pokerCards.cards[card.card].suit,
						pokerCards.cards[card.card].value
					);

					if (card.dealtTo === 'board') {
						boardCards = boardCards.concat(cardObj);
					} else {
						const playerIndex = Number(card.dealtTo.split('_')[1]) - 1;

						playerCards[playerIndex]
							? playerCards[playerIndex].push(cardObj)
							: playerCards[playerIndex] = [cardObj];
					}
				});
			})
		}

		const getWiningCombination = (data) => {
			return T.translate(
				pokerMap.keyMap[Object.keys(data.result).find(item => (item.includes('COMB') && data.result[item] === 'WON'))]
			)
		}

		const handTitleGen = () => {
			let returnVal = '';
			for(let i = 0; i < 6; i++) {
				returnVal = returnVal.concat(`<th>${T.translate('poker.hands.hand_' + (i + 1))}</th>`)
			}
			return returnVal;
		}
		const playerCardGen = (data) => {
			let returnVal = '';
			for(let i = 0; i < 6; i++) {
				if (Object.keys(data.result).find(item => item.includes(`PLAYER_${i + 1}`) && data.result[item] === 'WON')) {
					returnVal = returnVal.concat(`<td><div class="poker-winner">${playerCards[i]}</div></td>`)
				} else {
					returnVal = returnVal.concat(`<td><div>${playerCards[i]}</div></td>`)
				}
			}
			return returnVal.replace(/,/g, '');
		}

		function _setResultData(domBlock, data) {
			var results = '',
				counter = {
					game: ''
				},
				improvedMode = data.game === 'lucky6';


				if (data.game === 'poker') {
					getPokerCards(data);
					const pokerHistoryHtml = `<tr class="poker-result">
						<td>${Util.formatTime(new Date(data.startTime))}</td>
						<td>${data.code}</td>
						<td>${getWiningCombination(data)}</td>
						${playerCardGen(data)}
						<td><div>${boardCards.join().replace(/,/g, '')}</div></td>
					</tr>`;

					if (domBlock > 0) {
						$('body').find('tbody').append(
							pokerHistoryHtml
						);
						return;
					}

					$('body').find('.history').html(`
						<div class ="poker-history">
							<div>${T.translate('translate_prev')}</div>
							<table>
								<thead>
									<th>${T.translate('translate_latest_time')}</th>
									<th>${T.translate('translate_all_history')}</th>
									<th>${T.translate('translate_poker_combination')}</th>
									${handTitleGen()}
									<th>${T.translate('translate_poker_cards')}</th>
								</thead>
								<tbody>
								<tr class="poker-result">
									<td>${Util.formatTime(new Date(data.startTime))}</td>
									<td>${data.code}</td>
									<td>${getWiningCombination(data)}</td>
									${playerCardGen(data)}
									<td><div>${boardCards.join().replace(/,/g, '')}</div></td>
								</tr>
								</tbody>
							</table>
						</div>`
					)
					return;
				}


			if (improvedMode) {
				domBlock.find('.date .value').attr('data-real-time', data.startTime);
				domBlock.find('.date .value').html(Util.timeRange(data.startTime));
			} else {
				domBlock.find('.date .value').html(Util.formatTime(new Date(data.startTime)));
			}
			domBlock.find('.draw .value').html(data.code);

			if (data.cancelled) {
				results = T.translate('translate_cancelled');
			} else if (data.result && data.result.length) {
				counter.game = data.code;
				data.result.forEach(function (gameResult, j) {
					var result = gameResult;

					// If result has a letter strip it
					if ((/^[A-Z]/).test(gameResult)) {
						result = gameResult.slice(1);
					}
					if (improvedMode && !(j % 2)) {
						results += '<div class="results-block">';
					}
					results += '<div data-result="' + gameResult + '">' + result + '</div>';
					if (improvedMode && j % 2) {
						results += '</div>';
					}
					if (!counter[gameResult]) {
						counter[gameResult] = 0;
					}
					counter[gameResult]++;
				});
			} else {
				results = T.translate('translate_waiting');
			}
			domBlock.find('.results').html(results);
			domBlock.addClass('active');
		}

		// Roller helper functions
		function specialFormat(number) {
			var formattedNumber = (number * settings.games[0].conversionRate).toFixed(2),
				noParts = formattedNumber.split('.'),
				formatted = noParts[0].length < 4 ? _withDecimal(noParts) : _addSpacing(noParts[0]),
				currencySymbol =
					typeof settings.local.currencyMap[settings.games[0].currencySymbol] === 'string' ?
						settings.local.currencyMap[settings.games[0].currencySymbol] :
						settings.games[0].currencySymbol,
				numberString =
					settings.games[0].currencyFormat.replace(/%v/, formatted).replace(/%s/, currencySymbol);

			return numberString;

			function _withDecimal(numbers) {
				return numbers[0] + '<span class="decimal">,' + numbers[1] + '</span>';
			}

			function _addSpacing(spacingNum) {
				var result = [],
					pos = 0,
					i;

				for (i = spacingNum.length - 1; i >= 0; i--) {
					result.unshift(spacingNum[i]);
					pos++;
					if (pos % 3 || !i) {
						continue;
					}
					result.unshift('<span></span>');
				}
				return result.join('');
			}
		}

		function _updateHotAndColdNumbers(history, placement) {
			var alreadyExists = false,
				totals = {},
				topHot = '',
				topCold = '',
				keysSorted;

			if (history.cancelled || !history.result || !history.result.length) {
				return;
			}

			// Search if game already recorded
			alreadyExists = hotCold.some(function (draw) {
				return draw.uuid === history.uuid;
			});

			if (alreadyExists) {
				return;
			}

			if (hotCold.length >= 100) {
				hotCold.shift();
			}
			hotCold.push(history);

			hotCold.forEach(function (draw) {
				draw.result.forEach(function (ball) {
					totals[ball] += draw[ball];
				});
			});

			keysSorted = Object.keys(totals).sort(function (a, b) { return totals[b] - totals[a]; });

			topHot += '<div data-result="' + keysSorted[0] + '">' + keysSorted[0].slice(1) + '</div>';
			topHot += '<div data-result="' + keysSorted[1] + '">' + keysSorted[1].slice(1) + '</div>';
			topHot += '<div data-result="' + keysSorted[2] + '">' + keysSorted[2].slice(1) + '</div>';

			topCold += '<div data-result="' + keysSorted[keysSorted.length - 1] + '">' +
				keysSorted[keysSorted.length - 1].slice(1) + '</div>';
			topCold += '<div data-result="' + keysSorted[keysSorted.length - 2] + '">' +
				keysSorted[keysSorted.length - 2].slice(1) + '</div>';
			topCold += '<div data-result="' + keysSorted[keysSorted.length - 3] + '">' +
				keysSorted[keysSorted.length - 3].slice(1) + '</div>';

			const selectors = getGameSelectors(games[placement]);

			selectors.results.history.find('#cold-history .cold-hot-balls')
				.html(topCold);
			selectors.results.history.find('#hot-history .cold-hot-balls')
				.html(topHot);
		}

		function _updateTimes(gameNo) {
			const selectors = getGameSelectors(games[gameNo]);

			Util.setLocale(settings.games[gameNo].locale);
			selectors.results.all.find('.date .value').each(function () {
				var realTime = $(this).attr('data-real-time');

				$(this).html(Util.timeRange(realTime));
			});
			setTimeout(function () {
				_updateTimes(gameNo);
			}, 10000);
		}

		function actionAfterStream() {
			document.getElementById('content-wrapper').style.display = '';
			domBids.startSlider();
		}

		function actionBeforeStream() {
			document.getElementById('content-wrapper').style.display = 'none';
			domBids.stopSlider();
		}

		function showGameCode(gameNo, gameCode) {
			const selectors = getGameSelectors(games[gameNo]);

			selectors.header.gameCode.html(gameCode);
			selectors.header.gameCode.show();
		}

		return {
			loadTemplate: loadTemplate,
			showBets: showBets,
			showHistory: showHistory,
			showGameCode: showGameCode,
			showScreen: showScreen,
			setTimeLeft: setTimeLeft,
			setSlider: setSlider,
			actionBeforeStream: actionBeforeStream,
			actionAfterStream: actionAfterStream,
			setFullScreenPoker: setFullScreenPoker
		};
	}
);

